/** Grymwyrd English copy for the Play / VTT feature. */
export const playEn = {
  // CampaignList
  'play.campaigns.heading': 'My Campaigns',
  'play.campaigns.signIn': 'Sign in',
  'play.campaigns.signInToSee': 'to see the campaigns you have joined.',
  'play.campaigns.fallbackNotice': 'Showing example campaigns — your roster could not be loaded.',
  'play.campaigns.loading': 'Recalling your sagas…',
  'play.campaigns.empty': 'You have not joined any campaigns yet.',
  'play.campaigns.assignedCharacter': 'Assigned Character',
  'play.campaigns.unassigned': 'Unassigned',
  'play.campaigns.noCharactersYet': 'No characters yet',
  'play.campaigns.enterCampaign': 'Enter campaign',

  // CampaignPage — VTT prototype
  'play.vtt.theTable': 'The Table',
  'play.vtt.launch': 'Launch VTT',
  'play.vtt.iframeTitle': 'Grymwyrd VTT — campaign {campaignId}',
  'play.vtt.veilHeadline': 'The veil between table and tale is thin here.',
  'play.vtt.prototypeIntro':
    'The real-time virtual tabletop is a later phase. The interactive prototype will embed in this frame — press',
  'play.vtt.prototypeOutro': 'to ready the container.',

  // CampaignPage — encyclopedia sidebar
  'play.codex.heading': 'Codex Quick-Search',
  'play.codex.searchPlaceholder': 'Look up a monster, spell, rule…',
  'play.codex.searchAriaLabel': 'Search the encyclopedia',
  'play.codex.searching': 'Scrying…',
  'play.codex.noResults': 'Nothing found for “{q}”.',
  'play.codex.hint': 'Type at least two letters to search the living encyclopedia without leaving your table.',

  // CampaignPage — detail
  'play.campaign.fallbackTitle': 'Campaign',
  'play.campaign.fallbackDescription':
    'Campaign details could not be loaded — you can still prepare your character below.',
  'play.campaign.seoTitle': 'Campaign',
  'play.campaign.noneSpecified': 'No campaign specified.',
  'play.campaign.seoTitleNamed': '{title} — Play',
  'play.campaign.seoTitleDefault': 'Campaign — Play',
  'play.campaign.backToLobby': 'Back to lobby',
  'play.campaign.gm': 'GM {gm}',
  'play.campaign.playersCount': '{count} players',

  // CharacterSheet
  'play.sheet.savedToCodex': 'Saved to your codex.',
  'play.sheet.savedLocally': 'Saved locally (server unavailable).',
  'play.sheet.saveError': 'Could not save your character — storage is unavailable.',
  'play.sheet.loading': 'Unfurling the sheet…',
  'play.sheet.heading': 'Character Sheet',
  'play.sheet.avatarAlt': "{name}'s avatar",
  'play.sheet.unclaimedHero': 'Unclaimed hero',
  'play.sheet.abilityCheck': '{ability} check ({formula}):',
  'play.sheet.name': 'Name',
  'play.sheet.namePlaceholder': 'Nameless wanderer',
  'play.sheet.level': 'Level',
  'play.sheet.speciesLabel': 'Ancestry / Species',
  'play.sheet.loadingOption': 'Loading…',
  'play.sheet.selectSpecies': 'Select species',
  'play.sheet.classLabel': 'Class',
  'play.sheet.selectClass': 'Select class',
  'play.sheet.abilityScores': 'Ability Scores',
  'play.sheet.abilityScoresHint': '(click the modifier to roll)',
  'play.sheet.abilityScoreAria': '{ability} score',
  'play.sheet.rollCheckAria': 'Roll a {ability} check',
  'play.sheet.hp': 'HP',
  'play.sheet.maxHp': 'Max HP',
  'play.sheet.ac': 'AC',
  'play.sheet.backstory': 'Backstory',
  'play.sheet.backstoryPlaceholder': 'What darkness brought this soul to the table?',
  'play.sheet.canonCandidate': 'Canon Candidate',
  'play.sheet.canonCandidateHint': 'Opt this character in for consideration as part of the living Grymwyrd canon.',
  'play.sheet.saving': 'Saving…',
  'play.sheet.saveCharacter': 'Save Character',

  // CreateGameModal
  'play.create.errorNoName': 'Give your table a name.',
  'play.create.errorNoSystem': 'Choose a game system.',
  'play.create.you': 'You',
  'play.create.errorCreate': 'The ritual failed — your table could not be created. Try again shortly.',
  'play.create.modalTitle': 'Convene a Table',
  'play.create.successCopy': 'Your table is set. Share this invite link to summon your players.',
  'play.create.copyInviteAria': 'Copy invite link',
  'play.create.copied': 'Copied',
  'play.create.copy': 'Copy',
  'play.create.done': 'Done',
  'play.create.tableName': 'Table Name',
  'play.create.tableNamePlaceholder': 'e.g. The Mourning Vault',
  'play.create.quickStart': 'Quick Start',
  'play.create.quickStartAria': 'Quick-start presets',
  'play.create.customPreset': 'Custom',
  'play.create.customPresetDesc': 'Start from scratch',
  'play.create.gameSystem': 'Game System',
  'play.create.loadingSystems': 'Loading systems…',
  'play.create.systemFromPreset': '{system} (from preset)',
  'play.create.systemDefault': 'Grymwyrd Cataclysm (default)',
  'play.create.tags': 'Tags',
  'play.create.tagsUpTo': '(up to {count})',
  'play.create.removeTagAria': 'Remove tag {tag}',
  'play.create.tagLimitReached': 'Tag limit reached',
  'play.create.tagPlaceholder': 'horror, one-shot…',
  'play.create.maxPlayers': 'Max Players:',
  'play.create.cancel': 'Cancel',
  'play.create.convening': 'Convening…',
  'play.create.createTable': 'Create Table',

  // JoinPage
  'play.join.finding': 'Finding the table…',
  'play.join.expiredHeading': 'This invite has expired',
  'play.join.expiredBody': 'Codes time out for safety. Ask your host for a fresh one.',
  'play.join.browseLiveTables': 'Browse live tables',
  'play.join.errorHeading': 'We couldn’t reach the table',
  'play.join.errorBody': 'Something went wrong looking up your invite. Check your connection and try again.',
  'play.join.tryAgain': 'Try again',
  'play.join.defaultTableTitle': 'A Grymwyrd table',
  'play.join.invited': 'You’ve been invited to take a seat.',
  'play.join.signInToSeat': 'Sign in to take your seat',
  'play.join.createAccount': 'New here? Create a free account',
  'play.join.opensAfterSignIn': 'The table opens after you sign in.',

  // PlayLobbyPage
  'play.lobby.seoTitle': 'Play — Virtual Tabletop',
  'play.lobby.seoDescription':
    'Find a table, join a live session, and forge your legend at the Grymwyrd virtual tabletop.',
  'play.lobby.eyebrow': 'Virtual Tabletop',
  'play.lobby.title': 'Play',
  'play.lobby.subtitle':
    'Gather your coven. Roll the bones. Take your seat at a table where every choice echoes through the living canon of Grymwyrd.',
  'play.lobby.createGame': 'Create Game',
  'play.lobby.playNow': 'Play Now — no account needed',
  'play.lobby.signInToHost': 'Sign in to host your own table',

  // SessionListLive
  'play.live.heading': 'Live Now',
  'play.live.empty': 'No tables are live at this hour. The veil is quiet — start your own.',
  'play.live.badge': 'Live',
  'play.live.unknownSystem': 'Unknown system',
  'play.live.gmSuffix': ' · GM {gm}',
  'play.live.players': 'players',

  // TableList — empty board
  'play.tables.emptyHeading': 'No open tables yet',
  'play.tables.emptyBody':
    'The board is quiet for now. Be the first to pull up a chair — try the guest table instantly, no account needed.',
  'play.tables.tryGuestTable': 'Try the guest table',
  'play.tables.orUse': 'Or use',
  'play.tables.createGame': 'Create Game',
  'play.tables.aboveToHost': 'above to host your own.',

  // TableList — waitlist
  'play.waitlist.joinError': 'Could not join the waitlist — try again.',
  'play.waitlist.leaveError': 'Could not leave the waitlist — try again.',
  'play.waitlist.join': 'Join waitlist',
  'play.waitlist.leaving': 'Leaving…',
  'play.waitlist.leave': 'Leave waitlist',
  'play.waitlist.joining': 'Joining…',

  // TableList — board
  'play.tables.heading': 'Open Tables',
  'play.tables.openSeatOnly': 'Open seat only',
  'play.tables.systemFilterPlaceholder': 'System…',
  'play.tables.systemFilterAria': 'Filter by system',
  'play.tables.tagsFilterPlaceholder': 'Tags (comma-separated)…',
  'play.tables.tagsFilterAria': 'Filter by tags',
  'play.tables.fetchError': 'Could not reach the live board — the lobby is temporarily unavailable.',
  'play.tables.loading': 'Gathering tables…',
  'play.tables.untitledTable': 'Untitled table',
  'play.tables.full': 'Full',
  'play.tables.seatedCount': '{count} seated',
  'play.tables.viewTable': 'View Table',

  // ── Live chat (P-E) — per-recipient translation (Option A) ────────────────
  'chat.heading': 'Table Chat',
  'chat.empty': 'No messages yet. Say something to the table.',
  'chat.inputPlaceholder': 'Message the table…',
  'chat.inputAria': 'Chat message',
  'chat.send': 'Send',
  'chat.translatedFrom': 'Translated from {lang}',
  'chat.original': 'Original',
  'chat.showOriginal': 'Show original',
  'chat.showTranslation': 'Show translation',
  'chat.showOriginalsAll': 'Show originals',
  'chat.showTranslationsAll': 'Show translations',
  // Play modes: a campaign plays as the VTT table or as a living city
  'play.modes.city': 'City mode',
  'play.modes.cityIntro': 'Walk a living city as your character in this campaign, under its game system.',
  'play.modes.enterCity': 'Enter {city}',
  'play.modes.coreBlurb': 'The default campaign, open to everyone. Make a character, then play at the table or walk the city.',
  'play.modes.campaignLine': 'Campaign: {campaign}, playing {system}',
  'play.modes.playingAs': 'Playing as {name}',
  'play.modes.noCharacter': 'No character yet for this campaign.',
  'play.modes.manage': 'Campaign and character',
  'play.modes.narrative': 'This campaign plays the city as a story, without numbers.',
  'play.modes.enterLive': 'Live city: {city}',
  'play.modes.enterTurn': 'Turn-based city: {city}',
  'play.modes.liveMode': 'Live: the city runs on its own clock.',
  'play.modes.turnMode': 'Turn based: time stands still until the GM advances it.',
  'play.modes.vtt': 'Standard VTT: the GM uploads a map.',
  'play.modes.turnTitle': 'Turn-based time',
  'play.modes.turnAt': 'Time stands at {time}.',
  'play.modes.turnLoading': 'Finding the campaign tick.',
  'play.modes.turnAhead': 'Advance {span}',
  'play.modes.turnSlider': 'How far to advance the tick',
  'play.modes.turnTo': 'to {time}',
  'play.modes.turnAdvance': 'Advance',
  'play.modes.turnWait': 'The GM moves time. Walk and talk freely in the meantime.',
  // Applications: apply for a seat, the GM accepts or declines (5-seat cap)
  'play.apply.apply': 'Apply for a seat',
  'play.apply.applying': 'Applying…',
  'play.apply.withdraw': 'Withdraw application',
  'play.apply.waiting': 'Applied, number {position} in line',
  'play.apply.accepted': 'Accepted',
  'play.apply.declined': 'Not this time',
  'play.apply.signIn': 'Sign in to apply',
  'play.apply.error': 'Could not send that. Try again.',
  'play.apply.heading': 'Applications',
  'play.apply.intro': 'Players who applied to your tables. Accept up to {cap} players per table.',
  'play.apply.table': '{title}: {accepted} of {cap} seats filled',
  'play.apply.none': 'No one is waiting.',
  'play.apply.accept': 'Accept',
  'play.apply.decline': 'Decline',
  'play.apply.full': 'This table is full.',
  // Shardmasters (god only): assign people to RPGPublisher shards
  'play.shardmasters.title': 'Shardmasters',
  'play.shardmasters.intro': 'A shardmaster controls one or more shards: every setting in the shard and every city in those settings. They can view and moderate campaigns there and set city time, without debug.',
  'play.shardmasters.loading': 'Reading the shards…',
  'play.shardmasters.forbidden': 'Only the god account can assign shardmasters.',
  'play.shardmasters.error': 'Could not read the shards.',
  'play.shardmasters.target': 'Email or account id',
  'play.shardmasters.shard': 'Shard',
  'play.shardmasters.assign': 'Assign',
  'play.shardmasters.revoke': 'Revoke',
  'play.shardmasters.grants': 'Current shardmasters',
  'play.shardmasters.noGrants': 'No shardmasters yet.',
  'play.shardmasters.shards': 'Shards',
  'play.shardmasters.settingsIn': 'Settings: {list}',
  'play.shardmasters.noSettings': 'No settings yet',
  'play.shardmasters.fromEnv': 'set in the site environment',
  'play.shardmasters.saveError': 'Could not save that: {message}',
  // GM bubbles: merging two compatible tables playing the same city
  'play.bubbles.title': 'Merge tables',
  'play.bubbles.none': 'No other table with a compatible system is in this city right now.',
  'play.bubbles.nearby': '{gm} is running a {system} table here.',
  'play.bubbles.ask': 'Ask to merge',
  'play.bubbles.asked': 'Asked',
  'play.bubbles.asks': '{gm} asks to merge tables.',
  'play.bubbles.accept': 'Accept',
  'play.bubbles.decline': 'Decline',
  'play.bubbles.leading': 'You run the merged table.',
  'play.bubbles.following': 'Tables merged: {gm} runs it, and you play as a player.',
  'play.bubbles.overridden': 'The leader was set by an admin.',
  'play.bubbles.end': 'End the merge',
  'play.bubbles.makeLeader': 'Make {gm} the leader',
  'play.bubbles.thisTable': 'this table',
  'play.bubbles.error': 'The merge service did not answer.',
}
